import { AggregateState } from "@types";

export const findingStateDisplayName = (aggregateState: AggregateState) => {
  switch (aggregateState) {
    case "open":
      return "Open";
    case "fixed":
      return "Fixed";
    case "ignored-app":
      return "Ignored - Triage";
    case "ignored-code":
      return "Ignored - Code";
    case "removed":
      return "Removed";
  }
};
